import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import '../styles/legal.css';

const TermsOfUse = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Use - Excel Toolbox</title>
        <meta name="description" content="Terms of use for Excel Toolbox. Read about our service terms, conditions, and usage guidelines." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://exceltoolbox.org/terms-of-use" />
      </Helmet>
      <Container className="legal-container">
        <Card className="legal-card">
          <Card.Body>
            <h1>Terms of Use</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
            
            <h2 className="h4 mb-3">1. Acceptance of Terms</h2>
            <p>By accessing and using Excel Toolbox, a service provided by ByteBuilder Technologies, LLC ("we", "us", or "our"), you accept and agree to be bound by the terms and conditions of this agreement. These terms specifically govern your use of our Excel file processing and manipulation tools.</p>
            
            <h2 className="h4 mb-3">2. Use License</h2>
            <p>Excel Toolbox grants you a personal, non-exclusive, non-transferable license to use the application for personal or business purposes. This includes the use of our Excel file processing tools, format conversion utilities, and merging capabilities.</p>
            
            <h2 className="h4 mb-3">3. Data Privacy and Security</h2>
            <p>We take your data privacy seriously. Here's what you should know:</p>
            <ul>
              <li>All Excel file processing occurs entirely within your browser</li>
              <li>Your files are never uploaded to our servers</li>
              <li>We do not store, collect, or have access to any of your Excel file contents</li>
              <li>Any temporary data processing is cleared when you close your browser</li>
              <li>We recommend backing up your Excel files before processing them</li>
            </ul>
            
            <h2 className="h4 mb-3">4. Excel Processing</h2>
            <p>When using our Excel processing tools:</p>
            <ul>
              <li>You maintain full ownership and responsibility for your Excel files</li>
              <li>We process your files locally using browser-based technologies</li>
              <li>The application is provided "as is" without warranties</li>
            </ul>

            <h2 className="h4 mb-3">5. Trademark Acknowledgment</h2>
            <p>Excel® is a registered trademark of Microsoft Corporation in the United States and/or other countries. Excel Toolbox is not affiliated with, endorsed by, or sponsored by Microsoft Corporation. Any reference to Excel or Microsoft products is for descriptive purposes only and does not imply any association with Microsoft Corporation.</p>
            
            <h2 className="h4 mb-3">6. Limitations</h2>
            <p>You may not:</p>
            <ul>
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose without proper licensing</li>
              <li>Remove any copyright or other proprietary notations</li>
              <li>Attempt to decompile or reverse engineer any software contained within the application</li>
              <li>Use the application to process files containing sensitive personal information (such as SSNs, credit card numbers, etc.)</li>
            </ul>
            
            <h2 className="h4 mb-3">7. Disclaimer</h2>
            <p>The application is provided "as is" without any warranties. While we strive to maintain high quality and accuracy in our Excel processing tools, we do not guarantee that the application will be error-free or uninterrupted. You are responsible for verifying the accuracy of any processed files.</p>
            
            <h2 className="h4 mb-3">8. Trademark Disclaimer</h2>
            <p>Excel Toolbox is an independent tool created by ByteBuilder Technologies, LLC. We are not affiliated with, endorsed by, sponsored by, or in any way officially connected with Microsoft Corporation or any of its subsidiaries or affiliates. Microsoft®, Excel®, and related marks are registered trademarks of Microsoft Corporation.</p>
            <p>Our use of the term "Excel" is solely to indicate compatibility with Microsoft Excel file formats. All Microsoft product names, logos, and brands are property of Microsoft Corporation. The use of these names, logos, and brands does not imply endorsement.</p>

            <h2 className="h4 mb-3">9. Contact Information</h2>
            <p>If you have any questions about these Terms of Use, please contact us at info@bytebuildertech.com.</p>
            
            <h2 className="h4 mb-3">10. Governing Law</h2>
            <p>These terms shall be governed by and construed in accordance with the laws of your jurisdiction. ByteBuilder Technologies, LLC reserves all rights not expressly granted in these terms.</p>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default TermsOfUse;
